import React from "react";
import { FAQS } from "../mock";
import { Reveal, SectionEyebrow } from "./common";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export const FaqSection = () => (
  <section className="bg-brand-ivory py-20">
    <div className="mx-auto max-w-3xl px-5 md:px-8">
      <Reveal className="text-center">
        <SectionEyebrow center>Questions</SectionEyebrow>
        <h2 className="mt-4 font-serif text-3xl text-brand-ink md:text-4xl">Frequently Asked Questions</h2>
      </Reveal>
      <Reveal delay={100} className="mt-10">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="overflow-hidden rounded-2xl border border-brand-cream bg-white px-5"
            >
              <AccordionTrigger className="py-5 text-left font-serif text-lg text-brand-ink hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 font-sans text-[15px] leading-relaxed text-brand-muted">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
